module.exports = __webpack_public_path__ + "img/markit-meals.11a93518.png";